<template>
    <div class="block-editor send-waba-template-message">
        <a-spin class="spinner" :spinning="loading">
            <div class="editor-row">
                <div class="editor-row-title">Sonuç Gelene Kadar Bekle</div>
                <a-switch v-model="clone.waitForResponse" />
            </div>
            <div class="editor-row" v-if="clone.waitForResponse">
                <div class="editor-row-title">Bekleme Süresi (Saniye)</div>
                <a-input-number v-model="clone.waitTime" :min="30" :max="600" />
            </div>
            <div class="editor-row">
                <div class="editor-row-title">Channel</div>
                <a-select class="classic-new-select" placeholder="Whatsapp Business Channel" v-model="clone.channelId">
                    <a-select-option v-for="channel in businessChannels" :key="channel._id" :value="channel._id">
                        {{ channel.name }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="editor-row" v-if="clone.channelId">
                <div class="editor-row-title">
                    Template
                    <div class="material-icons" @click="previewMode = true">visibility</div>
                </div>
                <a-select
                    class="classic-new-select"
                    placeholder="Whatsapp Business Channel"
                    @change="selectTemplate"
                    :value="selectedTemplateId"
                >
                    <a-select-option v-for="(template, index) of templates" :key="index" :value="template.id">
                        {{ template.elementName }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="editor-row" v-if="selectedTemplateId">
                <div class="editor-row-title">Whatsapp Phone Number</div>
                <TiptapEditor
                    placeholder="Whatsapp Phone Number"
                    :show-attributes="true"
                    :max-character-count="500"
                    automation-mode
                    v-model="clone.phoneNumber"
                />
            </div>
            <div class="wpa-variables" v-if="selectedTemplateId && variables.length > 0">
                <div class="editor-row" v-for="(variable, index) of variables" :key="index">
                    <div class="editor-row-title">Variable (#{{ index + 1 }})</div>
                    <TiptapEditor
                        :placeholder="`Variable (#${index + 1})`"
                        :show-attributes="true"
                        :max-character-count="500"
                        v-model="clone.params[index]"
                        automation-mode
                    />
                </div>
            </div>
            <div
                class="image-picker"
                v-if="clone.template && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(clone.template.templateType)"
            >
                <div class="editor-row">
                    <div class="editor-row-title">Media Type</div>
                    <a-select v-model="mediaType" placeholder="Select Media Type">
                        <a-select-option value="static">Static</a-select-option>
                        <a-select-option value="dynamic">Dynamic</a-select-option>
                    </a-select>

                    <div v-if="mediaType === 'dynamic'">
                        <TiptapEditor
                            placeholder="Dynamic Media URL"
                            :show-attributes="true"
                            :max-character-count="500"
                            automation-mode
                            v-model="externalUrl"
                        />
                    </div>
                    <div v-if="mediaType === 'static'">
                        <div class="media-drag">
                            <div class="input">
                                <input
                                    type="file"
                                    id="media-source"
                                    :accept="getAcceptType()"
                                    @change="handleFileUpload"
                                />
                            </div>
                            <div class="material-icons">image</div>
                            <div class="content">Click here to upload a picture.</div>
                        </div>
                        <div class="description">
                            <div class="input-warn">
                                <div>
                                    <b>Note:</b> Following are the file formats and their respective sizes which are
                                    accepted for upload
                                </div>
                                <ul class="list-item">
                                    <li>Image: JPEG and PNG (Max size 2 MB)</li>
                                    <li>Video: MP4 (Max size 20 MB)</li>
                                    <li>Document: (Max size 2 MB)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </a-spin>
        <WhatsappMessagePreview
            :body="getTemplateParameters(clone.template).body"
            :footer="getTemplateParameters(clone.template).footer"
            :header-media-type="getTemplateParameters(clone.template).headerType"
            :header-text="getTemplateParameters(clone.template).headerText"
            :buttons="getTemplateParameters(clone.template).buttons"
            :headerMediaURL="getTemplateParameters(clone.template).headerMediaURL"
            v-if="clone.template"
        />
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import { mapActions, mapState } from "vuex";
import TemplateMessageSelector from "../../../../Whatsapp/pages/broadcast/create/TemplateMessageSelector.vue";
import { uploadAsset } from "../../../../../../api/assetUpload";
import axios from "axios";
import Modal2 from "../../../../../../components/common/Modal2.vue";
import WhatsappMessagePreview from "../../../../WhatsappBusiness/WhatsappMessagePreview.vue";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

const log = log2("SendWhatsappTemplateMessage");
export default {
    name: "SendWhatsappTemplateMessage",
    components: { WhatsappMessagePreview, Modal2, TemplateMessageSelector, TiptapEditor },
    props: ["value"],
    data() {
        return {
            loading: false,
            clone: _.cloneDeep(this.value),
            templates: [],
            selectedTemplateId: null,
            variables: [],
            media: null,
            useDefault: false,
            previewMode: false,
            mediaType: "static",
            externalUrl: "",
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
            businessChannels: (state) =>
                state.channel.channels.filter((channel) => channel.type === "whatsapp-business-api"),
        }),
    },
    methods: {
        ...mapActions({
            getTemplates: "whatsapp/getTemplates",
        }),
        getTemplateParameters(template) {
            const metaObject = JSON.parse(template.meta);
            const containerMetaObj = JSON.parse(template.containerMeta);

            return {
                headerType: template.templateType,
                headerMediaType: template.templateType,
                headerMediaURL:
                    this.mediaType === "dynamic"
                        ? ""
                        : this.media?.asset
                        ? this.media?.asset.url
                        : template.asset && (template.asset.v2Format && template.asset.cdnUrl
                          ? template.asset.cdnUrl
                          : `https://static.supsis.live/${template.asset.path}${template.asset.id}.${template.asset.ext}`),
                headerText: _.get(containerMetaObj, "header"),
                footer: _.get(containerMetaObj, "footer"),
                body: _.get(metaObject, "example") || metaObject.data,
                buttons: _.get(containerMetaObj, "buttons") || template.buttons,
            };
        },
        getChannelTemplates() {
            if (!this.clone.channelId) return;
            this.loading = true;
            this.getTemplates(this.clone.channelId).then((templates) => {
                this.loading = false;
                this.templates = templates;
                this.media = this.clone.asset && {
                    ...this.clone?.asset,
                    data: this.clone?.asset?.url,
                    asset: this.clone?.asset,
                };
                this.selectedTemplate = this.selectTemplate(this.clone.template?.id);
            });
        },
        selectTemplate(templateId) {
            const template = this.templates.find((t) => t.id === templateId);
            this.selectedTemplateId = templateId;
            this.clone.template = template;
            if (template) {
                this.getParams();
            }
        },
        getParams() {
            const template = this.clone.template;
            const templateType = template.templateType;
            const containerMetaObj = JSON.parse(template.containerMeta);
            const headerText = _.get(containerMetaObj, "header", "");
            let cardVariableSize = 0;
            if (templateType === "CAROUSEL") {
                const cards = containerMetaObj.cards;
                cardVariableSize = cards
                    .map((card) => {
                        return card.body.match(/{{\d+}}/g);
                    })
                    .flat()
                    .filter(Boolean).length;
            }
            const buttonVariableSize = (containerMetaObj.buttons || []).filter((button) => button.type === "URL").map((button) => {
                return button.url.match(/{{\d+}}/g);
            }).flat().filter(Boolean).length;
            this.variables = [
                ..._.uniq(headerText.match(/{{\d+}}/g)),
                ..._.uniq(template.data.match(/{{\d+}}/g)),
                ...new Array(cardVariableSize).fill(null),
                ...new Array(buttonVariableSize).fill(null),
            ].map(() => "");
            this.clone.params = new Array(this.variables.length).fill("").map((val, index) => {
                return this.clone.params[index] || val;
            });
        },
        async handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                const imageMime = ["image/jpeg", "image/png"];
                const videoMime = ["video/mp4"];
                const pdfMimeType = ["application/pdf"];
                const mb = file.size / 1024 / 1024;
                if (imageMime.includes(file.type) && mb >= 2) {
                    this.$message.error("The image could not be uploaded because it is more than 2 MB.", 3);
                    return;
                }
                if (videoMime.includes(file.type) && mb >= 20) {
                    this.$message.error("The video could not be uploaded because it is more than 20 MB.", 3);
                    return;
                }

                if (pdfMimeType.includes(file.type) && mb >= 2) {
                    this.$message.error("The document could not be uploaded because it is more than 2 MB.", 3);
                    return;
                }

                // here
                this.$message.loading("Image uploading, please wait...", 5);

                let path = `${this.siteId}/whatsapp-business/${this.clone.channelId}/assets/`;
                let imgUploadData = await uploadAsset({
                    path,
                    name: file.name,
                    size: file.size,
                    type: "gupshup-file",
                    mime: file.type,
                    ext: file.name.split(".").pop(),
                });

                await axios({
                    method: imgUploadData.data.method,
                    url: imgUploadData.data.url,
                    data: file,
                    headers: { "Content-Type": file.type },
                });

                this.media = {
                    data: URL.createObjectURL(file),
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    asset: {
                        id: imgUploadData.data.asset.id,
                        url: imgUploadData.data.asset.v2Format && imgUploadData.data.asset.cdnUrl
                            ? imgUploadData.data.asset.cdnUrl
                            : `https://static.supsis.live/${imgUploadData.data.asset.path}${imgUploadData.data.asset.id}.${imgUploadData.data.asset.ext}`,
                        name: file.name,
                        ext: imgUploadData.data.asset.ext,
                        path: imgUploadData.data.asset.path,
                    },
                };

                this.clone.asset = this.media.asset;
                this.$message.success("Resim başarılı bir şekilde yüklendi.");
            }
        },
        getAcceptType() {
            const templateType = this.clone.template.templateType;
            let types = [];
            if (templateType === "IMAGE") {
                types = _.concat(types, ["image/jpeg", "image/png"]);
            } else if (templateType === "VIDEO") {
                types = _.concat(types, ["video/mp4"]);
            } else if (templateType === "VIDEO") {
                types = _.concat(types, ["application/pdf"]);
            }
            return types.join(" ,");
        },
        deleteMedia() {
            this.media = null;
            this.clone.asset = null;
        },
    },
    mounted() {
        this.mediaType = this.clone.asset?.externalUrl ? "dynamic" : "static";
        this.externalUrl = this.clone.asset?.externalUrl || "";
        this.getChannelTemplates();
    },
    watch: {
        externalUrl: {
            deep: true,
            handler(newValue) {
                this.clone.asset = {
                    externalUrl: this.externalUrl,
                };
            },
        },
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        "clone.channelId": {
            deep: true,
            handler() {
                this.getChannelTemplates();
            },
        },
    },
};
</script>

<style lang="scss">
.template-preview-modal {
    .custom-modal-header {
        display: none !important;
    }

    .ant-modal-content {
        background: transparent !important;
        box-shadow: none;
    }

    .ant-modal-body {
        background: transparent !important;
    }

    .custom-modal-body {
        background: transparent !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.block-editor.send-waba-template-message {
    padding: 20px;
    display: flex;
    align-items: flex-start;
    gap: 20px;

    .ant-spin-nested-loading {
        width: 300px;
    }

    .ant-spin-container {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
            display: flex;
            align-items: center;
            gap: 5px;
        }
    }

    .wpa-variables {
        margin-top: 15px;
    }

    .image-picker {
        margin-top: 15px;

        .input-warn {
            background: #fff6e6;
            padding: 20px;

            .list-item {
                padding-left: 15px;
            }
        }

        .media-preview {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .media-preview-content {
                display: flex;
                align-items: center;
                gap: 10px;

                .media-preview-name {
                    font-weight: bold;
                }

                .media-image img {
                    height: 100px;
                }
            }

            .media-preview-delete {
                background: red;
                padding: 5px;
                border-radius: 100%;
                color: white;
                line-height: 0;
            }
        }

        .media-drag {
            display: flex;
            align-items: center;
            flex-direction: column;
            gap: 10px;
            border: 1px solid var(--color-border-default);
            padding: 40px;
            cursor: pointer;
            position: relative;

            .input {
                width: 100%;
                height: 100%;

                input {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0;
                }
            }

            .material-icons {
                font-size: 28px;
            }

            .content {
                font-size: 18px;
                font-weight: bold;
            }
        }
    }

    .classic-new-select {
        width: 100%;
        font-weight: bold;

        [role="combobox"] {
            padding: 4px;
            border: none !important;
            border-radius: 4px !important;
            background-color: #f1f1f1 !important;
        }
    }
}
</style>
